import RoundedButton from 'components/RoundedButton';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { ENTER_CTA_LINK, ENTER_FLOW_FIRST_STEP } from 'utils/cta/CTA';
import styles from './EnterButton.module.css';
import { EntryMethod } from 'components/enter/EntryMethod';

/** An button that takes the user to the first page of the enter flow. Its text will change depending on some state.
 * See implementation for details
 */
export const EnterButton = observer(() => {
  const enterStore = useEnterStore();
  return (
    <div className={styles.ctaButton}>
      <RoundedButton
        href={
          enterStore.isReferralFlow ? ENTER_FLOW_FIRST_STEP : ENTER_CTA_LINK
        }
        onClick={() =>
          enterStore.isReferralFlow &&
          enterStore.setEntryMethod(EntryMethod.PremiumSubscription)
        }
        rebrandDm2025
        colorStyle="Primary"
        fullWidth
      >
        {enterStore.isReferralFlow ? 'Claim 50% off' : 'Enter To Win'}
      </RoundedButton>
    </div>
  );
});
